module.exports = __webpack_public_path__ + "img/kangmingjian_img7.aeb2c980.jpg";